<template>
  <div>
    <el-card class="box-card">
      <div slot="header">
        <span>{{ $route.query.name }}</span>
      </div>
      <div v-if="$route.query.name == '主题说明'">
        <div v-for="(item, index) in subjectArr" :key="index">
          <div class="tui-subjectName">{{ item.Title }}：</div>
          <el-input
            maxlength="500"
            show-word-limit
            type="textarea"
            v-model="item.Desc"
            :rows="6"
          ></el-input>
        </div>

        <div class="flex-center" style="margin-top: 20px">
          <el-button type="primary" @click="onClickSubmitBtn">确定</el-button>
        </div>
      </div>
      <div v-if="$route.query.name != '主题说明'">
        <el-button type="primary" @click="onClickAdd">新增</el-button>
        <el-button type="primary" @click="uploadDialogVisible = true"
          >批量导入</el-button
        >
        <el-button type="primary" @click="onClickUploadFile"
          >模板下载</el-button
        >
        <el-row style="margin-top: 20px">
          <el-table
            :data="tableData"
            border
            style="width: 100%"
            :header-cell-style="{
              background: '#DBF4FF',
              color: '#333',
              textAlign: 'center',
            }"
            :cell-style="{ textAlign: 'center' }"
            empty-text="暂无数据"
          >
            <el-table-column label="序号" width="50">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="Title" label="主题名称"> </el-table-column>
            <el-table-column prop="KeyWords" label="关键词"> </el-table-column>
            <el-table-column prop="Describe" label="描述"> </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="onClickEdit(scope.row)"
                  >编辑</el-button
                >
                <el-button type="text" @click="Delete(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <template>
            <div v-for="list in secondDemos" :key="list.ThemeQuestionId">
              <div class="tui-edit" @click="dialogVisibleTitle = true">
                <span>{{ list.Title }}</span>
                <i class="el-icon-edit-outline" style="margin-left: 10px"></i>
              </div>
              <el-row style="margin-top: 20px">
                <el-col>
                  <el-select v-model="value" placeholder="请选择">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  <el-button
                    type="primary"
                    style="margin-left: 20px"
                    @click="onClickSubmit(list)"
                    >确定</el-button
                  >
                </el-col>
              </el-row>
            </div>
          </template>
        </el-row>
      </div>
    </el-card>
    <el-dialog title="批量导入" :visible.sync="uploadDialogVisible">
      <el-upload
        class="image-uploader"
        :multiple="false"
        :auto-upload="true"
        list-type="excel"
        :show-file-list="true"
        :drag="true"
        action
        :limit="1"
        :on-exceed="handleExceed"
        :before-upload="beforeUpload"
        :http-request="uploadFile"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将文件拖到此处，或
          <em>点击上传</em>
        </div>
        <div class="el-upload__tip" slot="tip">
          一次只能上传一个文件，仅限excel格式，单文件不超过5MB
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="SubmitUploadFile">提交</el-button>
        <el-button @click="uploadDialogVisible = false">取消</el-button>
      </div>
    </el-dialog>
    <!-- 新增/编辑 -->
    <el-dialog :title="Title" :visible.sync="dialogVisible" width="30%" center>
      <div>
        <el-form ref="form" :model="form" label-width="80px" :rules="rules">
          <el-form-item label="主题名称">
            <el-input
              v-model="$route.query.Title"
              placeholder="请输入主题名称"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="关键词" prop="keyword">
            <el-select
              v-model="form.keyword"
              @visible-change="dropdownAcademicSelectForm"
            >
              <el-option
                v-for="item in optionsStudyForm"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="排序值" prop="sort">
            <el-input
              v-model="form.sort"
              type="number"
              placeholder="请输入排序值"
            ></el-input>
          </el-form-item>
          <el-form-item label="描述" prop="desc">
            <el-input
              type="textarea"
              v-model="form.desc"
              maxlength="100"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">提 交</el-button>
      </span>
    </el-dialog>
    <!-- 编辑标题 -->
    <el-dialog
      title="编辑标题"
      :visible.sync="dialogVisibleTitle"
      width="30%"
      center
    >
      <div v-for="item in secondDemos" :key="item.ThemeQuestionId">
        <el-input v-model="item.Title"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleTitle = false">取 消</el-button>
        <el-button type="primary" @click="onClickEditTitle">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetEval_ThemeQuestionList,
  AddEval_ThemeQuestionInfo,
  GetKeyWords,
  FileUploadsExcel,
  ImportEval_ThemeQuestionInfo,
  DeleteThemeQuestionInfo,
  GetThemeDesc,
  SaveThemeDesc,
} from "../../api/api";
export default {
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      dialogVisibleTitle: false,
      uploadDialogVisible: false,
      SubjectForm: {},
      form: {
        sort: "",
        keyword: "",
        desc: "",
      },
      teacherName: "老师来加油！",
      options: [
        {
          value: "5",
          label: "无",
        },
        {
          value: "2",
          label: "图片",
        },
        {
          value: "3",
          label: "文字",
        },
        {
          value: "4",
          label: "图片+文字",
        },
      ],
      value: "5",
      Title: "",
      secondDemos: [],
      rules: {
        keyword: [
          { required: true, message: "请选择关键词", trigger: "change" },
        ],
        desc: [{ required: true, message: "请输入主题描述", trigger: "blur" }],
        sort: [{ required: true, message: "请输入排序值", trigger: "blur" }],
      },
      optionsStudyForm: [],
      themeQuestionId: 0,
      excelurl: "",
      subjectArr: [],
    };
  },
  created() {
    if (this.$route.query.name == "主题说明") {
      this.GetThemeDesc();
    } else {
      this.GetEval_ThemeQuestionList();
    }
  },
  methods: {
    async onClickSubmitBtn() {
      let res = await SaveThemeDesc({
        ThemeId: this.$route.query.ThemeId,
        desc: this.subjectArr,
      });
      if (res.data.success) {
        this.$message({
          type: "success",
          message: res.data.msg,
        });
        this.GetThemeDesc();
        this.$router.go(-1);
      } else {
        this.$message({
          type: "error",
          message: res.data.msg,
        });
      }
    },
    async GetThemeDesc() {
      let res = await GetThemeDesc({ ThemeId: this.$route.query.ThemeId });
      if (res.data.success) {
        this.subjectArr = res.data.response;
      }
    },
    onClickUploadFile() {
      window.open("http://www.mushroomisland.cn/exceldown/主题评价模板.xlsx");
    },
    SubmitUploadFile() {
      if (this.excelurl) {
        const params = {
          fileName: this.excelurl,
          eval_ThemeDetailId: this.$route.query.Eval_ThemeDetailId,
          themeId: this.$route.query.ThemeId,
        };
        ImportEval_ThemeQuestionInfo(params).then((res) => {
          if (res.data.success) {
            this.GetEval_ThemeQuestionList();
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.uploadDialogVisible = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      }
    },
    beforeUpload(file) {
      //console.log("beforeUpload");
      //console.log(file.type);
      const isText = file.type === "application/vnd.ms-excel";
      const isTextComputer =
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      return isText | isTextComputer;
    },
    // 上传文件个数超过定义的数量
    handleExceed() {
      this.$message.warning(`当前限制选择 1 个文件，请删除后继续上传`);
    },
    ////导入教师信息 上传选择文件
    uploadFile(item) {
      //console.log(item);
      //    //console.log(this.comId);
      const fileObj = item.file;
      // FormData 对象
      const form = new FormData();
      // 文件对象
      form.append("file", fileObj);
      //    form.append("comId", this.comId);
      form.append("filetype", "excel");
      //console.log(form);
      //debugger;
      FileUploadsExcel(form).then((response) => {
        this.excelurl = response.data.response;
        //console.log(response);
        //console.log(this.excelurl);
        this.$message.info("文件：" + fileObj.name + "上传成功");
      });
    },
    //删除
    Delete(scope) {
      DeleteThemeQuestionInfo({ id: scope.ThemeQuestionId }).then((res) => {
        if (res.data.success) {
          this.GetEval_ThemeQuestionList();
          this.$message({
            message: "删除成功",
            type: "success",
          });
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    // 提交
    onClickSubmit(item) {
      if (this.value != "") {
        const params = {
          themeQuestionId: this.secondDemos[0].ThemeQuestionId,
          eval_ThemeDetailId: this.$route.query.Eval_ThemeDetailId,
          themeId: this.$route.query.ThemeId,
          keyWordsId: 0,
          keyWords: "",
          describe: item.Title,
          sort: 0,
          questionType: this.value,
        };
        AddEval_ThemeQuestionInfo(params).then((res) => {
          if (res.data.success) {
            this.$message({
              type: "success",
              message: "成功",
            });
            this.GetEval_ThemeQuestionList();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
      } else {
        this.$message({
          type: "error",
          message: "请选择类型",
        });
      }
    },
    dropdownAcademicSelectForm(show) {
      if (show === true) {
        GetKeyWords({ Id: this.$route.query.TempleteId }).then((res) => {
          if (res.data.success) {
            this.optionsStudyForm = res.data.response;
          }
        });
      }
    },
    // 新增
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var obj = this.optionsStudyForm.find((x) => {
            return Number(this.form.keyword) == x.Id;
          });
          const params = {
            themeQuestionId:
              this.Title == "新增描述" ? 0 : this.themeQuestionId,
            eval_ThemeDetailId: this.$route.query.Eval_ThemeDetailId,
            themeId: this.$route.query.ThemeId,
            keyWordsId: this.form.keyword,
            keyWords: obj.Name,
            describe: this.form.desc,
            sort: this.form.sort,
            questionType: 1,
          };
          //console.log(params, "asdasdas");
          AddEval_ThemeQuestionInfo(params).then((res) => {
            if (res.data.success) {
              this.$message({
                type: "success",
                message: "成功",
              });
              this.GetEval_ThemeQuestionList();
              this.dialogVisible = false;
              this.form = {
                sort: "",
                keyword: "",
                desc: "",
              };
            } else {
              this.$message({
                type: "error",
                message: res.data.msg,
              });
            }
          });
        } else {
          //console.log("error submit!!");
          return false;
        }
      });
    },
    GetEval_ThemeQuestionList() {
      GetEval_ThemeQuestionList({
        Id: this.$route.query.Eval_ThemeDetailId,
      }).then((res) => {
        if (res.data.success) {
          this.tableData = res.data.response.question;
          this.secondDemos = res.data.response.secondDemos;
          this.value = String(res.data.response.secondDemos[0].QuestionType);
        } else {
          this.tableData = [];
        }
      });
    },
    onClickEditTitle() {
      this.dialogVisibleTitle = false;
    },
    onClickAdd() {
      this.Title = "新增描述";
      this.dialogVisible = true;
    },
    onClickEdit(item) {
      GetKeyWords({ Id: this.$route.query.TempleteId }).then((res) => {
        if (res.data.success) {
          this.themeQuestionId = item.ThemeQuestionId;
          this.Title = "编辑描述";
          this.optionsStudyForm = res.data.response;
          this.form = {
            sort: item.Sort,
            keyword: Number(item.KeyWordsId),
            desc: item.Describe,
          };
          this.dialogVisible = true;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.tui-subjectName {
  font-size: 16px;
  color: #333;
  font-weight: 500;
  padding: 20px 0;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.box-card {
  width: 100%;

  span {
    font-size: 22px;
    font-weight: 600;
  }
}

.tui-edit {
  display: flex;
  align-items: center;
  margin-top: 20px;

  span {
    font-size: 22px;
    font-weight: bold;
  }

  i {
    font-size: 25px;
  }
}
</style>